export const filterOptions = {
  DISEASES: [
    { value: 'diseaseUMLSCUI', label: 'Disease CUI' },
    { value: 'name', label: 'Disease Name' },
    { value: 'MSH', label: 'MESH' },
    { value: 'OMIM', label: 'OMIM' },
    { value: 'NCI', label: 'NCI' },
    { value: 'HPO', label: 'HPO' },
    { value: 'MONDO', label: 'MONDO' },
    { value: 'EFO', label: 'EFO' },
  ],
  VARIANTS: [
    { value: 'strID', label: 'VARIANT rs number' },
    { value: 'chromocoord', label: 'Chrom. position' },
    { value: 'proteinStrID', label: 'Protein mutation' },
  ],
  GENES: [
    { value: 'symbol', label: 'Gene symbol' },
    { value: 'name', label: 'Gene Name' },
    { value: 'ensemblID', label: 'Ensembl ID' },
    { value: 'uniprotID', label: 'Uniprot ID' },
    { value: 'geneID', label: 'Gene ID' },
  ],
  CHEMICALS: [
    { value: 'CHEMBL', label: 'Chembl ID' },
    { value: 'name', label: 'Chemical Name' },
    { value: 'CHEBI', label: 'Chebi ID' },
    { value: 'DRUGBANK', label: 'Drugbank ID' },
    { value: 'MESH', label: 'MESH' },
    { value: 'PUBCHEM', label: 'Pubchem ID' },
  ],
};



export const renderFilterOptions = (searchType, selectedFilter, setSelectedFilter) => {
  const currentFilters = filterOptions[searchType] || [];

  return (
    <select
      name="filter"
      value={selectedFilter}
      onChange={e => setSelectedFilter(e.target.value)}
      className="custom-dropdown"
    >
      {currentFilters.map(filter => (
        <option key={filter.value} value={filter.value}>
          {filter.label}
        </option>
      ))}
    </select>
  );
};

export const getExpectedFormatMessage = (searchType, selectedFilter) => {
  if (searchType === 'DISEASES') {
    if (selectedFilter === 'diseaseUMLSCUI') {
      return 'CUIs are: C0002736, C1862939, C2677565';
    } else if (selectedFilter === 'MSH') {
      return 'MESH IDs are: D014211, D003922, D003923';
    } else if (selectedFilter === 'OMIM') {
      return 'OMIM IDs are: 147450, 612069, 602432';
    } else if (selectedFilter === 'NCI') {
      return 'NCI IDs are: C34373, C34558, C131626';
    } else if (selectedFilter === 'HPO') {
      return 'HPO IDs are: HP:0009031, HP:0001250, HP:0004322';
    } else if (selectedFilter === 'MONDO') {
      return 'MONDO IDs are: 0005335, 0008315, 0004950';
    } else if (selectedFilter === 'EFO') {
      return 'EFO IDs are: 0001357, 0000474, 0000180';
    } else if (selectedFilter === 'name') {
      return 'Names are: Alopecia, Hypertension, Kyphosis';
    }
    // return selectedFilter === 'name'
    //   ? "Name is: Alzheimer's Disease"
    //   : 'CUIs are: C0002736, C1862939, C2677565';
  }
  if (searchType === 'VARIANTS') {
    if (selectedFilter === 'strID') {
      return 'rs numbers are: rs75290158, rs142200609, rs893051';
    } else if (selectedFilter === 'chromocoord') {
      return 'Positions are: 1:11796321, 6:31575254, 7:140753336';
    } else if (selectedFilter === 'proteinStrID') {
      return 'Protein mutations are: GJB2 Val153Ile, GJB2 V153F, USH2A P2811S';
    }
  }

  if (searchType === 'GENES') {
    if (selectedFilter === 'symbol') {
      return 'Symbols are: BRCA1, TP53, EGFR';
    } else if (selectedFilter === 'ensemblID') {
      return 'Ensembl IDs are: ENSG00000141510, ENSG00000134982, ENSG00000157764';
    } else if (selectedFilter === 'uniprotID') {
      return 'Uniprot IDs are: P04637, Q9BYF1, P38398';
    } else if (selectedFilter === 'geneID') {
      return 'IDs are: 672, 7157, 1956';
    } else if (selectedFilter === 'name') {
      return 'Names are: tumor necrosis factor, interleukin 10, hemoglobin subunit beta';
    }
  }

  if (searchType === 'CHEMICALS') {
    if (selectedFilter === 'CHEBI') {
      return 'ChEBI IDs are: 16236, 18258, 18243';
    } else if (selectedFilter === 'DRUGBANK') {
      return 'DrugBank IDs are: DB00002, DB00898, DB00997';
    } else if (selectedFilter === 'MESH') {
      return 'MeSH IDs are: D002945, D000431, D004317';
    } else if (selectedFilter === 'CHEMBL') {
      return 'ChEMBL IDs are: CHEMBL1251, CHEMBL4382, CHEMBL357328';
    } else if (selectedFilter === 'PUBCHEM') {
      return 'PubChem IDs are: 702, 2244, 60961';
    } else if (selectedFilter === 'name') {
      return 'Names are: Minoxidil, Doxorubicin, Cholecalciferol';
    }
  }
  return '';
};

export const getMsg = (searchType, selectedFilter) => {
  const messages = {
    DISEASES: {
      diseaseUMLSCUI: 'CUI',
      MSH: 'MESH',
    },
    VARIANTS: {
      strID: 'rs number',
    },
    GENES: {
      symbol: 'Symbol',
    },
    CHEMICALS: {
      CHEMBL: 'CUI',
    },
  };

  return messages[searchType]?.[selectedFilter] || '';
};

export const getItemCount = text => text.split('\n').filter(line => line.trim() !== '').length;

export const validateInput = (input, searchType, selectedFilter) => {
  if (searchType === 'DISEASES') {
    if (selectedFilter === 'diseaseUMLSCUI') {
      const cuiRegex = /^[A-Za-z0-9]{7,8}$/;
      return cuiRegex.test(input);
    }
    if (selectedFilter === 'name') {
      const chemNameRegex = /^[\p{L}\s\-'.,]+$/u;
      return chemNameRegex.test(input) && !/^C\d{7}$/.test(input);
    }
    if (selectedFilter === 'MSH') {
      const cuiRegex = /^[A-Za-z0-9]{7,8}$/;
      return cuiRegex.test(input);
    }
    if (selectedFilter === 'OMIM') {
      const omimRegex = /^\d{5,6}$/;
      return omimRegex.test(input);
    }

    if (selectedFilter === 'NCI') {
      const nciRegex = /^C\d{5,6}$/;
      return nciRegex.test(input);
    }

    if (selectedFilter === 'EFO') {
      const efoRegex = /^\d{7}$/;
      return efoRegex.test(input);
    }

    if (selectedFilter === 'DO') {
      const doRegex = /^\d{7}$/;
      return doRegex.test(input);
    }

    if (selectedFilter === 'ORDO') {
      const ordoRegex = /^\d{3}$/;
      return ordoRegex.test(input);
    }

    if (selectedFilter === 'HPO') {
      const hpoRegex = /^HP:\d{7}$/;
      return hpoRegex.test(input);
    }

    if (selectedFilter === 'MONDO') {
      const mondoRegex = /^\d{7}$/;
      return mondoRegex.test(input);
    }
  }
  if (searchType === 'VARIANTS') {
    if (selectedFilter === 'strID') {
      const rsidRegex = /^.*$/i;
      return rsidRegex.test(input);
    }
    if (selectedFilter === 'chromocoord') {
      const chrRegex = /^\d+:\d+$/;
      return chrRegex.test(input);
    }
    if (selectedFilter === 'proteinStrID') {
      const proteinMutationRegex = /^[A-Z0-9]+\s+[A-Z][a-z]{2}\d+[A-Z][a-z]{2}$/;
      const proteinMutationOneLetterRegex = /^[A-Z0-9]+\s+[A-Z]\d+[A-Z]$/;
      return proteinMutationRegex.test(input) || proteinMutationOneLetterRegex.test(input);
    }
  }
  if (searchType === 'GENES') {
    if (selectedFilter === 'symbol' || selectedFilter === 'geneSymbol') {
      const geneSymbolRegex = /^(?!rs)[A-Z][A-Za-z0-9-]{0,19}$/;
      return geneSymbolRegex.test(input);
    }
    if (selectedFilter === 'geneID' || selectedFilter === 'geneId') {
      const geneIDRegex = /^\d+$/;
      return geneIDRegex.test(input);
    }
    if (selectedFilter === 'ensemblID' || selectedFilter === 'ensemblId') {
      const ensemblIDRegex = /^ENSG\d{11}$/;
      return ensemblIDRegex.test(input);
    }
    if (selectedFilter === 'uniprotID' || selectedFilter === 'uniprotId') {
      const uniprotIDRegex = /^(?:[OPQ][0-9][A-Z0-9]{3}[0-9]|[A-NR-Z][0-9]([A-Z][A-Z0-9]{2}[0-9]){1,2})$/i;
      return uniprotIDRegex.test(input);
    }
    if (selectedFilter === 'name') {
      const chemNameRegex = /^(?!rs)\p{L}[\p{L}0-9\- ]{1,49}$/u;
      return chemNameRegex.test(input);
    }
  }
  if (searchType === 'CHEMICALS') {
    if (selectedFilter === 'name') {
      const chemNameRegex = /^[\p{L}\s\-'.,]+$/u;
      return chemNameRegex.test(input) && !/^C\d{7}$/.test(input);
    }
    if (selectedFilter === 'CHEBI') {
      const tmpRegex = /^[0-9]+$/;
      return tmpRegex.test(input);
    }
    if (selectedFilter === 'DRUGBANK') {
      const tmpRegex = /^[A-Za-z0-9_-]+$/;
      //const tmpRegex = /^(DB|db)\d+$/;
      return tmpRegex.test(input);
    }
    if (selectedFilter === 'MESH') {
      const tmpRegex = /^[A-Za-z0-9_-]+$/;
      //const tmpRegex = /^D|d\d+$/;
      return tmpRegex.test(input);
    }
    if (selectedFilter === 'CHEMBL') {
      const tmpRegex = /^[A-Za-z0-9_-]+$/;
      //const tmpRegex = /^CHEMBL\d+$/;
      return tmpRegex.test(input);
    }
    if (selectedFilter === 'PUBCHEM') {
      const tmpRegex = /^[0-9]+$/;
      return tmpRegex.test(input);
    }
  }
  return false;
};
